import { render, staticRenderFns } from "./EditDiscountCoupons.vue?vue&type=template&id=205f165c&"
import script from "./EditDiscountCoupons.vue?vue&type=script&lang=js&"
export * from "./EditDiscountCoupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports